angular.module('SpidApp')

.provider('Toaster',
[        'ngToastProvider',
function (ngToastProvider) {

	var TIMEOUT = 7 * 1000 // 7 seconds

	var Toaster = ['ngToast', function (ngToast) {
		return {
			show: function (content) {
				return ngToast.success({
					content: content,
					timeout: TIMEOUT
				});
			},
			warning: function (content) {
				return ngToast.warning({
					content: content,
					timeout: TIMEOUT
				});
			},
			danger: function (content) {
				return ngToast.danger({
					content: content,
					timeout: TIMEOUT
				});
			}
		}
	}]

	this.$get = Toaster

	this.configure = ngToastProvider.configure
}])